import { HONEYPOT_FIELD } from '@/lib/formSpamGuard';

/**
 * Campo oculto para usuarios reales; los bots suelen rellenarlo.
 * No usar display:none puro (algunos scrapers lo ignoran mejor con posición fuera de pantalla).
 */
export default function FormHoneypot() {
  return (
    <div
      className="absolute w-px h-px p-0 -m-px overflow-hidden whitespace-nowrap border-0"
      style={{ clip: 'rect(0,0,0,0)', clipPath: 'inset(50%)' }}
      aria-hidden="true"
    >
      <label htmlFor={HONEYPOT_FIELD}>Website</label>
      <input
        type="text"
        name={HONEYPOT_FIELD}
        id={HONEYPOT_FIELD}
        tabIndex={-1}
        autoComplete="off"
        defaultValue=""
      />
    </div>
  );
}
